import * as R from 'ramda'
import { Message } from '@weblite/ts-action/message'
import {
  monthAndYearFormatter,
  monthFormatter,
  yearFormatter,
} from '$func/time'

const formatDate = (timestamp: number) => {
  const messageDate = new Date(timestamp)
  const currentYear = yearFormatter.format(new Date())
  const messageYear = yearFormatter.format(messageDate)

  const formatter =
    currentYear === messageYear ? monthFormatter : monthAndYearFormatter
  return formatter.format(messageDate)
}

type DateSeparator = { type: 'DATE_SEPARATOR'; date: string }
const createDateSeparator = (date: string): DateSeparator => ({
  type: 'DATE_SEPARATOR',
  date,
})

export type MediaListRow = DateSeparator | Message[]

export function formatMessages(messages: Message[], columnCount: number) {
  const formattedMessages: MediaListRow[] = []

  R.pipe(
    R.groupBy(({ date }) => formatDate(date)),
    R.forEachObjIndexed((monthMessages, formattedMonth) =>
      formattedMessages.push(
        createDateSeparator(formattedMonth),
        ...R.splitEvery(columnCount, monthMessages),
      ),
    ),
  )(messages)

  return formattedMessages
}
